<template>
  <table class="cus-eval-score" ref="refEvalScore" :name="options.Key">
    <colgroup>
      <col style="width: 150px">
      <col v-for="(obj, i) in options.TableColumns" :key="i" :style="colWidth">
    </colgroup>
    <tbody>
      <tr class="cus-table-thead">
        <th class="cus-table-index">评分内容&emsp;档次</th>
        <th v-for="(column, i) in options.TableColumns" :key="i">
          {{column.Name}}
        </th>
      </tr>
      <template v-for="(obj, i) in rows" :key="i">
        <tr>
          <td>
            <p class="tsw-p bold">{{obj.CONTENT}}</p>
          </td>
          <td v-for="(column, j) in options.TableColumns" :key="j">
            <p class="text-center">
              <!-- {{`${options.Key}[${i}].${column.Key}`}} -->
              <el-form-item v-msg class="tender-form-label wp100" style="margin: 0" label-width="0" :prop="`${options.Key}[${i}].${column.Key}`" :name="column.Key" :rules="[]">
                <bear-input v-model="obj[column.Key]" :attrs="inputAttrs"></bear-input>
              </el-form-item>
            </p>
          </td>
        </tr>
        <tr>
          <td :colspan="1 + options.TableColumns.length">
            <p class="text-left" style="white-space: break-spaces;">
              <el-form-item v-msg class="tender-form-label wp100" style="margin: 0" label-width="0" :prop="`${options.Key}[${i}].EXPLAIN`" name="EXPLAIN" :rules="[]">
                <bear-input v-model="obj.EXPLAIN"></bear-input>
              </el-form-item>
            </p>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
import { mixForFormItem } from '../../../js/mixins'
import utils from '../../../js/utils'
import BearInput from '~@/input/src'
export default {
  name: 'FormEvalScoreJzsj',
  components: {
    BearInput,
  },
  mixins: [mixForFormItem],
  computed: {
    colWidth() {
      return `width: ${700 / this.options.TableColumns.length}px`
    },
    inputAttrs() {
      return {
        minWidth: `${690 / this.options.TableColumns.length - 50}px`
      }
    },
    value() {
      let {options, form} = this
      return form[options.Key] || []
    }
  },
  data() {
    return {
      rows: []
    }
  },
  created() {
    this.setDefaultValue()
  },
  methods: {
    setDefaultValue() {
      let {form = {}, options} = this
      utils.readyToSetFormItemDefault(form, options).then(() => {
        if(options.Value) {
          form[options.Key] = options.Value
          this.rows = options.Value
        } else {
          form[options.Key] = this.rows
        }
        this.$nextTick(() => {
          this.doValidate()
        })
      }).catch(() => {
        this.rows = form[options.Key] || []
        this.$nextTick(() => {
          this.doValidate()
        })
      })
    },
    inputChangeHandle() {
      this.doValidate()
    },
    getRequiredCount() {
      return 0
    }
  },
  watch: {
    value() {
      this.rows = this.value
      this.$nextTick(() => {
        this.doValidate()
      })
    }
  }
}
</script>
<style lang="scss" scope>
.cus-eval-score {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  thead, .cus-table-thead {
    background: #EEF1F6;
  }
  th, td {
    padding: 10px;
    vertical-align: middle;
    border: 1px solid #DFE6EC
  }
  p {
    margin: 0;
    .el-form-item__error {
      top: 0;
    }
  }
  .cus-table-index {
    position: relative;
    &:before {
      content: "";
      width: 1px;
      height: 45px;
      display: block;
      position: absolute;
      top: -2px;
      left: 85px;
      border-right: 1px solid black;
      transform: rotate(152deg);
    }
  }
}
</style>